import { LoadingIndicator } from "devextreme-react/bar-gauge";
import InvoicesItem from "./InvoicesItem";
import LoadingSpinner from "../../Components/LoadingSpinner";
import { useTranslation } from "react-i18next";

const InvoiceItems = ({ items, isLoading }) => {
  const { t } = useTranslation();
  return (
    <div className="table-responsive table-items">
      <table className="table table-bordered">
        <thead>
          <tr>
            <th style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px', fontWeight: 'normal', width: '10%' }}>Indeks</th>
            <th style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px', fontWeight: 'normal', width: '60%' }}>Nazwa <br /> Cecha</th>
            <th style={{ alignContent: "center", verticalAlign: 'middle', textAlign: 'right', fontSize: '14px', fontWeight: 'normal', width: '10%' }}>Ilość</th>
            <th style={{ alignContent: "center", textAlign: 'right', fontSize: '14px', fontWeight: 'normal', width: '10%' }}><span style={{ fontWeight: "bold" }}>Cena brutto</span><br />Cena netto</th>
            <th style={{ alignContent: "center", textAlign: 'right', fontSize: '14px', fontWeight: 'normal', width: '10%' }}><span style={{ fontWeight: "bold" }}>Wartość brutto</span><br />Wartość netto</th>
          </tr>
        </thead>
        <tbody>
          {!isLoading && items &&
            items.map((item, index) => {
              return <InvoicesItem key={index} item={item} />;
            })}
        </tbody>
      </table>
      {isLoading && <LoadingSpinner width={2} height={2} />}
      {!isLoading && items && items.length === 0 && (
        <div style={{ textAlign: "center" }}>
          {t("message_norecords_table_invoices_items_page")}
        </div>
      )}
    </div>
  );
};

export default InvoiceItems;
